var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBuildAndScaleLines = function SvgBuildAndScaleLines(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 310,
    viewBox: "0 0 520 310",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6996_30901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.44 -26.2422L343.42 519.178",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.39 -26.2422L299.37 519.178",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.34 -26.2422L255.31 519.178",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.28 -26.2422L211.26 519.178",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.23 -26.2422L167.21 519.178",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.18 -26.2422L123.16 519.178",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.12 -26.2422L79.0996 519.178",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.07 -26.2422L35.0498 519.178",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.02 -26.2422L-9 519.178",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.86 170.319H411.09L454.83 -26.8281H474.6L430.86 170.319Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.8 170.319H367.03L410.78 -26.8281H430.55L386.8 170.319Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.75 170.319H322.98L366.72 -26.8281H386.49L342.75 170.319Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.7 170.319H278.93L322.67 -26.8281H342.44L298.7 170.319Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.64 170.319H234.87L278.62 -26.8281H298.39L254.64 170.319Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.59 170.319H190.82L234.57 -26.8281H254.34L210.59 170.319Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.541 170.319H146.771L190.511 -26.8281H210.281L166.541 170.319Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.49 170.319H102.72L146.46 -26.8281H166.23L122.49 170.319Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4302 170.319H58.6602L102.41 -26.8281H122.18L78.4302 170.319Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6996_30901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 520,
    height: 310
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBuildAndScaleLines);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";